<!--
 @description 左侧菜单栏
 @author xiehan
 @date 2018/9/19
-->
<template>
  <el-menu class="el-menu-vertical" 
    :default-openeds="defaultOpen"
    :default-active="defaultActive"
    @select="selectMenu">
    <el-button class="loading-btn" :loading="true" v-show="loading">{{ $t('common.loading') }}</el-button>
    <el-submenu v-for="(level1Item, level1Index) in menuList" 
      :key="level1Index" 
      :index="level1Item.name">
      <div slot="title">
        <i class="iconfont" :class="[{ 'f-weight': level1Item.menuUrl === 'icon-delivery'}, level1Item.menuUrl]"></i>
        <span v-text="level1Item.name"></span>
      </div>
      <el-menu-item-group>
        <el-menu-item v-for="(level2Item, level2Index) in level1Item.childMenu" 
          :key="level2Index" 
          :index="level2Item.name" 
          v-if="level2Item.childMenu.length === 0">
          <span slot="title" v-text="level2Item.name"></span>
        </el-menu-item>
      </el-menu-item-group>
      <el-submenu v-for="(level2Item, level2Index) in level1Item.childMenu" 
          :key="level2Index" 
          :index="level2Item.name" 
          v-if="level2Item.childMenu.length > 0">
          <span slot="title" v-text="level2Item.name"></span>
          <el-menu-item v-for="(level3Item, level3Index) in level2Item.childMenu" 
            :key="level3Index" 
            :index="level3Item.name">
            <span slot="title" v-text="level3Item.name"></span>
          </el-menu-item>
      </el-submenu>
    </el-submenu>
  </el-menu>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import menu from '@/router/index'

export default {
  name: 'mainMenu',
  data () {
    return {
      loading: true
    }
  },
  computed: {
    ...mapState({
      globalMenu: state => state.menuModule.menuList,
      menuList: state => state.menuModule.filterMenuList,
      defaultOpen: state => state.menuModule.defaultOpenMenu,
      defaultActive: state => state.menuModule.defaultActiveMenu,
      tabList: state => state.tabModule.tabList
    })
  },
  methods: {
    // 菜单选择事件
    selectMenu (key) {
      let seletInfo = this.$store.getters.findMenuByName(key)
      let code = seletInfo.code
      if (menu.options.routes[3].children.filter(item => item.name === code).length === 0) {
        this.$message({
          message: this.$t('common.menuMissing'),
          type: 'error'
        })
        return
      }
      this.$router.push({ name: code })
      if (this.$store.getters.findTabIndexByCode(code) >= 0) {
        this.$router.push({ path: this.tabList[this.$store.getters.findTabIndexByCode(code)].fullPath })
      } else {
        this.$router.push({ name: code })
      }
      this.addTab(key)
    },
    // 增加tab
    addTab (name, init = false) {
      let addInfo = init ? this.$store.getters.findMenuByCode(name) : this.$store.getters.findMenuByName(name)
      this.$store.commit('setActiveTab', addInfo.code)
      if (this.$store.getters.findTabByName(name)) return
      this.$store.commit('addTab', addInfo)
    },
    init (code) {
      this.addTab(code, true)
      this.$store.commit('setActiveTab', this.$store.getters.findMenuByCode(code).code)
      this.$store.commit('setActiveMenu', code)
      this.$store.commit('setFullPath', {
        code: code,
        fullPath: this.$route.fullPath
      })
    },
    setMenuScrollTop () {
      const scorllBox = document.getElementsByTagName('aside')[0]
      const markLi = document.getElementsByClassName('is-active')[0] ? document.getElementsByClassName('is-active')[0] : ''
      if (markLi) {
        scorllBox.scrollTop = markLi.offsetTop
      }
    },
    getGlobalMenu (val) {
      let pageInfo = val.find(item => item.code === this.$route.name && item.inPage)
      if (pageInfo) {
        this.init(this.$route.name)
      } else {
        pageInfo = val.find(item => item.code === this.$route.path.split('/')[2])
        if (pageInfo) {
          this.init(this.$route.path.split('/')[2])
        }
      }
    },
    getMenuList (val) {
      if (val.length > 0) this.loading = false
      this.$nextTick(this.setMenuScrollTop)
    }
  },
  mounted() {
    this.getGlobalMenu(this.globalMenu)
    this.getMenuList(this.menuList)
  }
}
</script>

<style>
  .el-submenu__title {
    font-size: 14px;
    font-weight: bolder;
    color: #333333;
    background: #F3F3F3;
  }
  .el-menu-item {
    font-size: 12px;
    color: #666666;
  }
  .el-menu-item-group__title {
    display: none;
  }
  .el-menu-vertical {
    position: relative;
    overflow: hidden;
  }
  .el-menu-vertical .iconfont {
    font-size: 18px;
    color: #999;
    vertical-align: middle;
  }
  .el-menu-vertical .loading-btn {
    text-align: center;
    border: none; 
    color: #000;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  .f-weight {
    font-weight: bolder;
  }
</style>